const routes = [
    {
        path: "/",
        component: () => import("../Pages/Home.vue"),
        name: "home",
    },
    {
        path: "/apvidvardi",
        component: () => import("../Pages/AllRegionalWords.vue"),
        name: "allRegionalWords",
    },
    {
        path: "/par-mums",
        component: () => import("../Pages/About.vue"),
        name: "about",
    },
    {
        path: "/par-sikdatnem",
        component: () => import("../Pages/CookiesPolicy.vue"),
        name: "cookiesPolicy",
    },
    {
        path: "/par-talku",
        component: () => import("../Pages/AboutProject.vue"),
        name: "aboutProject",
    },
    {
        path: "/talkas-statistika",
        component: () => import("../Pages/Statistics.vue"),
        name: "statistics",
    },
    {
        path: "/instrukcija",
        component: () => import("../Pages/Instruction.vue"),
        name: "instruction",
    },
    {
        path: "/kontakti",
        component: () => import("../Pages/Contacts.vue"),
        name: "contacts",
    },
    {
        path: "/privatuma-politika",
        component: () => import("../Pages/PrivacyAndTerms.vue"),
        name: "privacyAndTerms",
    },
    {
        path: "/paroles/atjaunosana/:token",
        component: () => import("../Pages/PasswordReset.vue"),
        name: "passwordReset",
    },
    {
        path: "/paroles-atjaunosanas-pieprasijums",
        component: () => import("../Pages/SendResetPasswordLink.vue"),
        name: "sendResetPasswordLink",
    },
    {
        path: "/apvidvards/:id",
        component: () => import("../Pages/RegionalWordView.vue"),
        name: "regionalWordView",
    },
    {
        path: "/epasta/apstiprinasana/:id/:hash",
        component: () => import("../Pages/EmailVerification.vue"),
        name: "emailVerification",
    },
    {
        path: "/lietotajs-apstiprinats",
        component: () => import("../Pages/UserApproved.vue"),
        name: "userApproved",
    },
    {
        path: "/lietotaja-konts",
        component: () => import("../Pages/UserProfile.vue"),
        name: "userProfile",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "*",
        component: () => import("../Pages/PageNotFound.vue"),
        name: "pageNotFound",
    },
];

export default routes;
